export default __webpack_public_path__ + "static/media/stamindashboard.a36ac55c.jpg";